"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.decodeWireSegment = decodeWireSegment;
const decoded_types_1 = require("../decoded-types");
const sigma_engine_shared_1 = require("@cadstrom/sigma-engine-shared");
const decode_tc31_visual_label_1 = require("./decode-tc31-visual-label");
function decodeWireSegment(node, path, warnings) {
    if (node.type !== 'container' && node.type !== 'econtainer') {
        warnings.push({
            type: decoded_types_1.DecodeWarningType.UnrecognizedShape,
            message: `expected container for tc:11 (WireSegment), got ${node.type}`,
            severity: sigma_engine_shared_1.BoundaryLevel.Warning,
            path,
        });
        return node;
    }
    const c = node.children;
    if (c.length !== 15) {
        return node;
    }
    const startCoord = (0, decode_tc31_visual_label_1.readCadencePosition)(c[3]);
    const endCoord = (0, decode_tc31_visual_label_1.readCadencePosition)(c[5]);
    const bboxQuad = (0, decode_tc31_visual_label_1.readCoordsContainer)(c[7]);
    if (startCoord === null || endCoord === null) {
        warnings.push({
            type: decoded_types_1.DecodeWarningType.UnrecognizedShape,
            message: `tc:11 (WireSegment) missing start (${startCoord === null}) or end (${endCoord === null}) coord container`,
            severity: sigma_engine_shared_1.BoundaryLevel.Warning,
            path,
        });
    }
    return {
        kind: 'wire-segment',
        startCoord,
        endCoord,
        bbox: bboxQuad,
        raw: node,
    };
}
function stripPrefix(s, prefix) {
    if (!s.startsWith(prefix)) {
        return null;
    }
    return s.slice(prefix.length);
}
//# sourceMappingURL=decode-tc11-wire-segment.js.map